import { render, staticRenderFns } from "./RouteOfAdministrationStatuses.vue?vue&type=template&id=68718930&scoped=true&"
import script from "./RouteOfAdministrationStatuses.vue?vue&type=script&lang=js&"
export * from "./RouteOfAdministrationStatuses.vue?vue&type=script&lang=js&"
import style0 from "./RouteOfAdministrationStatuses.vue?vue&type=style&index=0&id=68718930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68718930",
  null
  
)

export default component.exports